var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaughing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#252c37}.cls-3{fill:#f25268}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 240.92,
    fill: "#ffd972",
    style: {
      fill: "#ffd972"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.12 321.81c61.11 0 115.19 9.37 148.26 23.76-1.19 2.15-2.45 4.26-3.76 6.35a127.12 127.12 0 0 0 21.67-70.64c0-5.34-322.58-4.95-322.58 0a126.61 126.61 0 0 0 18.93 66.35c-1-1.73-2-3.48-2.89-5.25 33.44-12.57 83.9-20.57 140.37-20.57z",
    fill: "#252c37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256 422.32c-59.81 0-112-28.46-139.86-70.75q-1.29-1.95-2.5-3.94c1.31 2.29 2.68 4.56 4.13 6.78 27.51 42 79.07 70.3 138.15 70.3 60.23 0 112.62-29.41 139.7-72.79-27.9 42.08-79.98 70.4-139.62 70.4z",
    fill: "#f25268"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M256 422.32c59.64 0 111.72-28.31 139.62-70.4 1.31-2.09 2.57-4.2 3.76-6.35-33.07-14.39-87.15-23.76-148.26-23.76-56.47 0-106.93 8-140.37 20.57.92 1.77 1.89 3.52 2.89 5.25q1.22 2 2.5 3.94C144 393.86 196.19 422.32 256 422.32z",
    fill: "#f25268"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94 163.84 62.32 32.61c5.94 3.11 13.51 1.53 17-4.46 3.27-5.6 1.51-13.89-4.46-17l-62.32-32.62c-5.95-3.11-13.51-1.52-17 4.46-3.27 5.6-1.51 13.89 4.47 17z",
    fill: "#252c37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m106.85 229.48 62.32-32.62c5.94-3.11 7.73-11.41 4.46-17-3.53-6-11-7.59-17-4.46L94.29 208c-5.94 3.12-7.73 11.42-4.46 17 3.53 6 11 7.58 17 4.46zM405.43 142.36 343.11 175c-5.95 3.11-7.74 11.41-4.46 17 3.53 6 11 7.59 17 4.46L418 163.84c5.95-3.12 7.74-11.41 4.47-17-3.53-6-11.05-7.58-17-4.46z",
    fill: "#252c37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.71 208-62.32-32.61c-5.95-3.11-13.52-1.52-17 4.46-3.27 5.6-1.51 13.89 4.46 17l62.32 32.62c6 3.11 13.52 1.52 17-4.46 3.27-5.6 1.51-13.89-4.46-17z",
    fill: "#252c37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaughing);
export default __webpack_public_path__ + "static/media/laughing.c433a05be15a8573a9cee39ca700011b.svg";
export { ForwardRef as ReactComponent };